<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'CardBox1',
})
</script>
<template>
  <Collapse v-model:activeKey="activeKey">
    <Collapse.Panel key="1" :showArrow="false">
      <template #header>
        <div :class="bem('hd')">{{ title }}</div>
      </template>
      <Skeleton :loading="loading" active :paragraph="{ rows: 4 }">
        <div :class="bem('bd')">
          <slot />
        </div>
      </Skeleton>
    </Collapse.Panel>
  </Collapse>
</template>

<script lang="ts" setup name="CardBox1">
import { createNamespace } from '@bd/vue3-utils'
import { Skeleton, Collapse } from 'ant-design-vue'
import { ref } from 'vue'
withDefaults(
  defineProps<{
    title: string
    loading?: boolean
  }>(),
  {
    loading: false
  }
)
const [_, bem] = createNamespace('CardBox1')
const activeKey = ref(['1'])
</script>

<style lang="less">
.card-box1 {
  border-radius: @border-radius-large;
  overflow: hidden;

  &__hd {
    font-size: 16px;
    line-height: 24px;
  }
}
</style>
